import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navigation from "./components/Navigation";
import { AuthProvider } from "./state/auth";
import { OrderProvider } from "./state/order";
import PrivateRoute from "./components/PrivateRoute";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import SubscribeSuccess from "./pages/SubscribeSuccess";
import Welcome from "./pages/Welcome";
import Status from "./pages/Status";
import Browse from "./pages/Browse";
import Toy from "./pages/Toy";
import Register from "./pages/Register";
import Footer from "./components/Footer";
import "./App.css";
import BasketModal from "./modals/BasketModal";
import { BasketUIProvider, useBasketUI } from "./state/basketUi";
import { RegisterProvider } from "./state/register";
import Signup from "./pages/Signup";

function App() {
  return (
    <Router>
      <AuthProvider>
        <OrderProvider>
          <RegisterProvider>
            <BasketUIProvider>
              <div className="App truculenta-main">
                <Navigation />
                <Routes>
                  <Route path="/" element={<Landing />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/browse" element={<Browse />} />
                  <Route path="/toy/:name" element={<Toy />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/signup" element={<Signup />} />
                  <Route
                    path="/subscribe-success"
                    element={<SubscribeSuccess />}
                  />
                  <Route
                    path="/welcome"
                    element={
                      <PrivateRoute>
                        <Welcome />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/status"
                    element={
                      <PrivateRoute>
                        <Status />
                      </PrivateRoute>
                    }
                  />
                </Routes>
              </div>
              <Footer />
              <BasketModalWrapper />
            </BasketUIProvider>
          </RegisterProvider>
        </OrderProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;

// Inline wrapper to mount BasketModal with global UI state
const BasketModalWrapper: React.FC = () => {
  const { open, closeBasket } = useBasketUI();
  return <BasketModal open={open} onClose={closeBasket} />;
};
